export const ToAbsoluteUrl = (pathName: string) => {
    return process.env.PUBLIC_URL + pathName;
};
